// 认证相关模拟数据

// 登录用户模拟数据
export const mockLoginUser = {
  id: '1',
  username: 'admin',
  nickname: '管理员',
  email: 'admin@example.com',
  phone: '13800138000',
  avatar: 'https://avatars.githubusercontent.com/u/1?v=4',
  status: 1,
  roles: ['admin'],
  permissions: [
    'dashboard:view',
    'user:view',
    'user:list',
    'user:add',
    'user:edit',
    'user:delete',
    'role:view',
    'role:list',
    'role:add',
    'role:edit',
    'role:delete',
    'menu:view',
    'menu:list',
    'menu:add',
    'menu:edit',
    'menu:delete',
    'permission:view',
    'permission:list',
    'web3:view',
    'web3:lottery:view',
    'web3:approve:view',
    'web3:batch-transfer:view',
    'web3:ipfs:view',
    'web3:liren:view',
    'web3:liren:overview:view',
    'web3:liren:admin:view',
    'web3:liren:compensation:view',
    'web3:liren:vesting:view',
    'web3:liren:pair:view',
    'taiji:view',
    'system:view',
    'system:config:view',
    'system:config:basic',
    'system:config:advanced',
    'system:log:view',
    'figma:view',
    'figma:article:view',
    'figma:signup:view',
    'figma:ecommerce:view',
    'figma:finance-academy:view',
    'figma:user-profile:view',
    'figma:chaiyao-home:view',
  ],
  createTime: '2024-01-01 10:00:00',
  updateTime: '2024-01-01 10:00:00',
}

// 登录凭据模拟数据
export const mockLoginCredentials = {
  username: 'admin',
  password: '123456',
  remember: true,
}

// 登录响应模拟数据
export const mockLoginResponse = {
  token: 'mock-jwt-token-' + Date.now(),
  refreshToken: 'mock-refresh-token-' + Date.now(),
  expiresIn: 7200, // 2小时
  user: mockLoginUser,
}

// 用户权限模拟数据
export const mockUserPermissions = {
  permissions: [
    {
      id: '1',
      name: '用户查看',
      code: 'user:view',
      resource: 'user',
      action: 'view',
      type: 'menu',
      status: 1,
    },
    {
      id: '2',
      name: '用户添加',
      code: 'user:add',
      resource: 'user',
      action: 'add',
      type: 'button',
      status: 1,
    },
  ],
  permissionCodes: [
    'dashboard:view',
    'user:view',
    'user:list',
    'user:add',
    'user:edit',
    'user:delete',
    'role:view',
    'role:list',
    'role:add',
    'role:edit',
    'role:delete',
    'menu:view',
    'menu:list',
    'menu:add',
    'menu:edit',
    'menu:delete',
    'permission:view',
    'permission:list',
  ],
}

// 系统信息模拟数据
export const mockSystemInfo = {
  version: '1.0.0',
  name: '后台管理系统',
  description: '基于React + Vite + Ant Design的后台管理系统',
  author: 'Admin',
  license: 'MIT',
  buildTime: '2024-01-01 10:00:00',
  nodeVersion: 'v18.17.0',
  platform: 'win32',
  uptime: 86400, // 1天
}

// 字典数据模拟
export const mockDictData = {
  user_status: [
    { id: '1', code: 'active', name: '正常', value: '1', sort: 1, status: 1 },
    { id: '2', code: 'inactive', name: '禁用', value: '2', sort: 2, status: 1 },
    { id: '3', code: 'pending', name: '待审核', value: '3', sort: 3, status: 1 },
  ],
  role_status: [
    { id: '1', code: 'active', name: '正常', value: '1', sort: 1, status: 1 },
    { id: '2', code: 'inactive', name: '禁用', value: '2', sort: 2, status: 1 },
  ],
  menu_type: [
    { id: '1', code: 'directory', name: '目录', value: 'directory', sort: 1, status: 1 },
    { id: '2', code: 'menu', name: '菜单', value: 'menu', sort: 2, status: 1 },
    { id: '3', code: 'button', name: '按钮', value: 'button', sort: 3, status: 1 },
  ],
  permission_type: [
    { id: '1', code: 'directory', name: '目录', value: 'directory', sort: 1, status: 1 },
    { id: '2', code: 'menu', name: '菜单', value: 'menu', sort: 2, status: 1 },
    { id: '3', code: 'button', name: '按钮', value: 'button', sort: 3, status: 1 },
  ],
}

// 配置数据模拟
export const mockConfigData = [
  {
    key: 'system.name',
    value: '后台管理系统',
    type: 'string',
    description: '系统名称',
    group: 'system',
    sort: 1,
    isSystem: true,
  },
  {
    key: 'system.version',
    value: '1.0.0',
    type: 'string',
    description: '系统版本',
    group: 'system',
    sort: 2,
    isSystem: true,
  },
  {
    key: 'upload.maxSize',
    value: '10485760',
    type: 'number',
    description: '上传文件最大大小（字节）',
    group: 'upload',
    sort: 1,
    isSystem: false,
  },
  {
    key: 'upload.allowedTypes',
    value: '["image/jpeg", "image/png", "image/gif", "application/pdf"]',
    type: 'json',
    description: '允许上传的文件类型',
    group: 'upload',
    sort: 2,
    isSystem: false,
  },
]
